"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const AmountFiat = ({ amount, currency, locale = 'us', }) => {
    let minimumFractionDigits = 0;
    let maximumFractionDigits = 0;
    const val = Math.abs(amount);
    if (val >= 0.01) {
        minimumFractionDigits = 2;
        maximumFractionDigits = 2;
    }
    if (val < 0.01 && val >= 0.001) {
        minimumFractionDigits = 5;
        maximumFractionDigits = 5;
    }
    if (val < 0.001) {
        minimumFractionDigits = 8;
        maximumFractionDigits = 8;
    }
    if (val === 0) {
        minimumFractionDigits = 2;
        maximumFractionDigits = 2;
    }
    const currencyFormatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits,
        maximumFractionDigits,
    });
    const amountFormatted = currencyFormatter.format(amount);
    return react_1.default.createElement(react_1.default.Fragment, null, amountFormatted);
};
exports.default = AmountFiat;
//# sourceMappingURL=AmountFiat.js.map